<div
    (click)="goToStripe()"
    *ngIf="show"
    class="py-2 px-3 add-hover align-items-center bg-warning justify-content-center"
>
    <div class="container">
        <div class="row align-items-center">
            <div class="col-md-3 col-12 d-flex align-items-center">
                <i class="bi bi-exclamation-triangle me-3 med"></i>
                <b>Information needed!</b>
            </div>
            <div class="col border-left">
                We need to collect additional info to keep payments and payouts
                enabled. This is part of required bank account verification.
                <u>Click to verify &raquo;</u>
            </div>
        </div>
    </div>
</div>
